import {
  createDeviceGroupAsync,
  deleteDeviceGroupAsync,
  getAllDeviceGroupByLicenseAsync,
  getDeviceGroupByIdAsync,
  updateDeviceGroupAsync,
} from '../../index';
import { useMutation } from 'react-query';

export const useCreateDeviceGroupAsync = () =>
  useMutation(createDeviceGroupAsync);

export const useGetDeviceGroupByIdAsync = () =>
  useMutation(getDeviceGroupByIdAsync);

export const useGetAllDeviceGroupByLicenseAsync = () =>
  useMutation(getAllDeviceGroupByLicenseAsync);

export const useUpdateDeviceGroupAsync = () =>
  useMutation(updateDeviceGroupAsync);

export const useDeleteDeviceGroupAsync = () =>
  useMutation(deleteDeviceGroupAsync);
